import { AxiosResponse } from "axios";
import { apiInstance } from "@/store/configureStore";

export const cancelTimeOffRequest = async (id: number) => {
  const response: AxiosResponse = await apiInstance.post(
    `/time-off/booking/${id}/cancel`
  );

  return response.data;
};
